import React from 'react';
import KakaoAdBanner from './KakaoAdBanner';

function getMediaQuery(query) {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return null;
  }
  return window.matchMedia(query);
}

function useMediaQuery(query) {
  const [matches, setMatches] = React.useState(() => {
    return getMediaQuery(query)?.matches || false;
  });

  React.useEffect(() => {
    const mediaQuery = getMediaQuery(query);
    if (!mediaQuery) return undefined;
    const handleChange = (event) => setMatches(event.matches);

    setMatches(mediaQuery.matches);

    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', handleChange);
    } else {
      mediaQuery.addListener(handleChange);
    }

    return () => {
      if (mediaQuery.removeEventListener) {
        mediaQuery.removeEventListener('change', handleChange);
      } else {
        mediaQuery.removeListener(handleChange);
      }
    };
  }, [query]);

  return matches;
}

export function MobileReportAd({ className }) {
  const showMobileAd = useMediaQuery('(max-width: 900px)');

  if (!showMobileAd) return null;

  return (
    <KakaoAdBanner
      className={`report-mobile-ad d-print-none ${className || ''}`}
      placement="mobile"
    />
  );
}

export default function ReportAdLayout({ children, className, contentClassName }) {
  const showSideAd = useMediaQuery('(min-width: 1280px)');

  return (
    <main className={`report-ad-shell ${className || ''}`}>
      <div className={`report-ad-main ${contentClassName || ''}`}>
        {children}
      </div>
      {showSideAd && (
        <aside className="report-ad-rail d-print-none" aria-label="광고">
          <KakaoAdBanner placement="desktop" />
        </aside>
      )}
    </main>
  );
}
